

















import { Vue, Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { State } from 'vuex-class';
import cloneDeep from 'lodash/cloneDeep';
// Components
import BaseFullCalendar from '@/components/common/BaseFullCalendar/Index.vue';
import BaseDatePicker from '@/components/common/BaseDatePicker.vue';
import ModalUpdateReservation from './ModalUpdateReservation.vue';
// Constants
import {
  formatDate,
  formatTime,
  formatDateTime2,
} from '@common/app.config';
import { COLORS } from '@common/app.config';
import {
  addReservationMinutesInTokyo,
  formatReservationInTokyo,
} from '@/common/helpers/datetime-tokyo';

@Component({
  components: {
    BaseFullCalendar,
    ModalUpdateReservation,
    BaseDatePicker,
  },
  computed: {
    ...mapState('auth', ['currentUser']),
  },
})
export default class Calendar extends Vue {
  @Prop(Array) readonly reservations!: any;
  @State((state) => state.auth.currentUser) currentUser!: any;

  isChanged: boolean = false;
  isSubmiting: boolean = false;
  isDelete: boolean = false;
  reservationEdit: object = {};

  get events() {
    const data = this.reservations
      .filter((x) => x.user)
      .map((x) => {
        const { reservation_date, ampm1 } = x;
        const itemDefault = {
          user_id: '',
          time: '',
          title: '',
          textColor: COLORS.WHITE,
          backgroundColor: `#${this.currentUser.color}`,
          borderColor: `#${this.currentUser.color}`,
        };
        const durationMinutes = ampm1 ? parseInt(ampm1, 10) : 20;
        const date = formatReservationInTokyo(reservation_date, formatDate);
        const startDateTime = formatReservationInTokyo(
          reservation_date,
          formatDateTime2,
        );
        const startTime = formatReservationInTokyo(reservation_date, formatTime);
        const endDateTime = addReservationMinutesInTokyo(
          reservation_date,
          durationMinutes,
          formatDateTime2,
        );
        const endTime = addReservationMinutesInTokyo(
          reservation_date,
          durationMinutes,
          formatTime,
        );
        const title = `${startTime} ~ ${endTime}`;
        return {
          ...cloneDeep(itemDefault),
          ...cloneDeep(x),
          title,
          current_date: date,
          time: startTime,
          start: startDateTime,
          end: endDateTime,
        };
      });
    return data;
  }

  eventClick(info) {
    const reservation = this.events.find((x) => x.id === +info.event.id);
    if (!reservation) {
      return;
    }
    const cloneReservation = cloneDeep(reservation);
    this.reservationEdit = {
      ...cloneReservation,
      id: cloneReservation.id,
      date: cloneReservation.current_date,
      time: cloneReservation.time,
    };
    this.$modal.show('modalUpdateReservation');
  }

  onChangeGrid(data) {
    const { type, date } = data;
    const params = {
      search_by: type,
      date,
    };
    this.$emit('setSearchOptions', params);
    this.$emit('fetchDataCalendar');
  }

}
